module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/056-guinea-bissau-1ce86ebbba91aa8e302e73e9d900efc8.svg";